import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl

const API_URL = `${BackendURL}/employees`;

export const fetchEmployees = createAsyncThunk("employees/fetchEmployees", async () => {
  const response = await axiosInstance.get(API_URL);
  return response.data;
});

export const addEmployee = createAsyncThunk("employees/addEmployee", async (employeeData, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(API_URL, employeeData);
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message || "Connection Error!";
    return rejectWithValue(errorMessage);
  }
});

export const updateEmployee = createAsyncThunk("employees/updateEmployee", async ({ id, ...employeeData }) => {
  const response = await axiosInstance.put(`${API_URL}/${id}`, employeeData);
  return response.data;
});

export const deleteEmployee = createAsyncThunk("employees/deleteEmployee", async (id) => {
  await axiosInstance.delete(`${API_URL}/${id}`);
  return id; // Returning ID to update state
});

const employeeSlice = createSlice({
  name: "employees",
  initialState: {
    employees: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployees.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchEmployees.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.employees = action.payload;
      })
      .addCase(fetchEmployees.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addEmployee.fulfilled, (state, action) => {
        state.employees.push(action.payload);
      })
      .addCase(updateEmployee.fulfilled, (state, action) => {
        const index = state.employees.findIndex((emp) => emp.id === action.payload.id);
        if (index !== -1) {
          state.employees[index] = action.payload;
        }
      })
      .addCase(deleteEmployee.fulfilled, (state, action) => {
        state.employees = state.employees.filter((emp) => emp.id !== action.payload);
      });
  },
});

export default employeeSlice.reducer;
